import axios from "axios";
import { Markup } from "interweave";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import {
  buildStyles,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";
import { useHistory, useParams } from "react-router-dom";
import { serverInfo } from "../../../../../../../App";
import calendar from "../../../../../../../assets/images/meetupEvent/calendar.png";
import Clock from "../../../../../../../assets/images/meetupEvent/clock-icon.png";
import "./ConfirmEditMarketplace.css";
import Dolar from "../../../../../../../assets/images/dollarSign.webp";
import Product from "../../../../../../../assets/images/Downloads/package.png";
// import clock from '../../../../../assets/images/meetupEvent/clock.png'

const CricketJerseySouvenir = () => {
  const { imageCdnUrl } = useContext(serverInfo);
  const { id } = useParams();

  const [title, setTitle] = useState("");
  const [unit_price, setUnitPrice] = useState("");
  const [total_items, setTotalItems] = useState("");
  const [total_selling, setTotalSelling] = useState("");
  const [image, setImage] = useState();
  const [description, setDescription] = useState("");
  const [terms_conditions, setTermsConditions] = useState("");

  const [post_status, setPostStatus] = useState(0);
  const [status, setStatus] = useState(0);

  let history = useHistory();

  function handleClick() {
    // history.push('/superstar-admin/souvenir/live-biddings');
    history.push("/superstar-admin/marketplace");
  }

  useEffect(() => {
    axios.get(`/api/admin/marketplace/product-edit/${id}`).then((res) => {
      if (res.data.status === 200) {
        setTitle(res.data.editData.title);
        setUnitPrice(res.data.editData.unit_price);
        setTotalItems(res.data.editData.total_items);
        setImage(res.data.editData.image);
        setTotalSelling(res.data.editData.total_selling);
        setDescription(res.data.editData.description);
        setTermsConditions(res.data.editData.terms_conditions);
        setPostStatus(res.data.editData.post_status);
        setStatus(res.data.editData.status);
      }
    });
  }, []);

  return (
    <div className="container-fluid">
      <div className="row my-3">

        <div className="col-md-6 mb-1">
          <div className="">
            <div className="registration-body  card-bg m-0 pt-3">
              <div className="row mb-5 m-2">
                <div className="col-md-6 m-0 ">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2">
                      <span className="text-light">
                        <img src={Product} alt="" className="PriceTage" />
                      </span>
                    </div>
                    <div className=" mx-1">
                      <span className=" text-warning fw-bold">
                        <p className="text-warning fw-bold">
                          <h6>Units</h6>
                          {total_items} Pieces
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 m-0 ">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2">
                      <span className="text-light">
                        <img src={Dolar} alt="" className="PriceTage" />
                      </span>
                    </div>
                    <div className=" mx-1">
                      <span className=" text-warning fw-bold">
                        <p className="text-warning fw-bold">
                          <h6>Unit Price</h6>
                          {unit_price} $
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 m-0 ">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2">
                      <span className="text-light">
                        <img src={Dolar} alt="" className="PriceTage" />
                      </span>
                    </div>
                    <div className=" mx-1">
                      <span className=" text-warning fw-bold">
                        <p className="text-warning fw-bold">
                          <h6>Total Sellings</h6> {total_selling} Pieces
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="card card-bg shadow">
            <div className="card-body">
              <h3 className="text-light fw-bold mb-3">{title}</h3>
              <p className="text-light">
                <b style={{ color: "gold" }}>Description</b>
                <Markup content={description} />
              </p>
            </div>
          </div>

          <div className="card card-bg shadow">
            <div className="card-body">
              <p className="text-light">
                <b style={{ color: "gold" }}>Terms Conditions</b>
                <Markup content={terms_conditions} />
              </p>
            </div>
          </div> */}

          {/* <div className=" d-flex mt-5 mb-5 cricket-jersey">
            <div className="d-flex p-4 registration-btn">
              <div className="mt-2  mx-3 ">
                <span className="text-light">
                  {" "}
                  <img src={calendar} alt="" className="PriceTage" />
                </span>
              </div>
              <div className=" mx-1">
                <span className="text-light">Units</span>
                <br></br>
                <span className="text-warning BtnTextNMP Usd fw-bold">
                  {total_items} Pieces
                </span>
              </div>
            </div>

            <div className=" d-flex p-4 registration-btn ">
              <div className=" mt-2 mx-3">
        
              </div>
              <div className=" mx-1 ">
                <span className="text-light">Unit Price</span>
                <br></br>
                <span className="text-warning  BtnTextNMP Usd fw-bold">
                  {unit_price} $
                </span>
              </div>
            </div>

            <div className="d-flex p-4 registration-btn">
              <div className="mt-2  mx-3 ">
                <span className="text-light">
                  {" "}
                  <img src={calendar} alt="" className="PriceTage" />
                </span>
              </div>
              <div className=" mx-1">
                <span className="text-light">Total Sellings</span>
                <br></br>
                <span className="text-warning BtnTextNMP Usd fw-bold">
                  {total_selling} Pieces
                </span>
              </div>
            </div>
          </div> */}



        </div>
    <div className="col-md-6">
        <img
    src={imageCdnUrl + image}
    alt="Pineapple"
    className="img-fluid  Cricket-Img"
    style={{ border: "2px solid gold", height: "260px" }}
    />
    </div>
      </div>

      <div className="row mb-4">
        <div className="col-md-12">
          {/* <div className="">
            <div className="registration-body  card-bg m-0 pt-3">
              <div className="row mb-5 m-2">
                <div className="col-md-4 m-0 ">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2">
                      <span className="text-light">
                        <img src={calendar} alt="" className="PriceTage" />
                      </span>
                    </div>
                    <div className=" mx-1">
                      <span className=" text-warning fw-bold">
                        <p className="text-warning fw-bold">
                          <h6>Units</h6>
                          {total_items} Pieces
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 m-0 ">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2">
                      <span className="text-light">
                        <img src={Clock} alt="" className="PriceTage" />
                      </span>
                    </div>
                    <div className=" mx-1">
                      <span className=" text-warning fw-bold">
                        <p className="text-warning fw-bold">
                          <h6>Time</h6>
                          {unit_price} $
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 m-0 ">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2">
                      <span className="text-light">
                        <img src={calendar} alt="" className="PriceTage" />
                      </span>
                    </div>
                    <div className=" mx-1">
                      <span className=" text-warning fw-bold">
                        <p className="text-warning fw-bold">
                          <h6>Total Sellings</h6> {total_selling} Pieces
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          <div className="card card-bg shadow">
            <div className="card-body">
              <h3 className="text-light fw-bold mb-3">{title}</h3>
              <p className="text-light">
                <b style={{ color: "gold" }}>Description</b>
                <Markup content={description} />
              </p>
            </div>
          </div>
        </div>
        <div className="mt-1">
          <div className="card card-bg shadow">
            <div className="card-body">
              <p className="text-light">
                <b style={{ color: "gold" }}>Terms Conditions</b>
                <Markup content={terms_conditions} />
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="card card-bg">
        <div className="row">
          <div className="col-md-4 d-flex justify-content-center align-items-center">
            <img src={Clock} className="img-fluid p-3" alt="" />
          </div>
          <div className="col-md-4 d-flex align-items-center">
            <div>
              <h2 className="text-warning">Marketplace submitted</h2>
              <p className="text-light">
                {status == 1 ? (
                  <span className="fw-bold">Already Published</span>
                ) : (
                  ""
                )}
                {status == 0 && post_status == 1 ? (
                  <span className="fw-bold">
                    Waiting for &nbsp; Manager Admin Approval
                  </span>
                ) : (
                  ""
                )}
                {status == 0 && post_status == 0 ? (
                  <span className="fw-bold">
                    Waiting for &nbsp; Star & Manager Admin Approval
                  </span>
                ) : (
                  ""
                )}
                {/* {(status === '1') ? (<span className="fw-bold">Already Published</span>) : (Number(post_status) === '1') ? (<span className="fw-bold">Waiting for &nbsp; Manager Admin Approval</span>) : (<span className="fw-bold">Waiting for &nbsp; Star & Manager Admin Approval</span>)} */}
                &nbsp;
              </p>
            </div>
          </div>

          <div className="col-md-4" style={{ borderLeft: "1px dashed yellow" }}>
            <h5 className="text-light text-center my-3">Status</h5>
            <div className="d-flex justify-content-center align-items-center ">
              <div style={{ width: 150, height: 150 }}>
                {Number(status) === 1 ? (
                  <CircularProgressbarWithChildren
                    value={100}
                    styles={buildStyles({ pathColor: `gold` })}
                  >
                    {/* <img style={{ width: 40, marginTop: -4 }} className='my-2' src={star} alt="doge" /> */}
                    <div style={{ fontSize: 12, marginTop: -5 }}>
                      <strong className="text-light">100% complete</strong>
                    </div>
                  </CircularProgressbarWithChildren>
                ) : Number(post_status) === 1 ? (
                  <CircularProgressbarWithChildren
                    value={50}
                    styles={buildStyles({ pathColor: `gold` })}
                  >
                    {/* <img style={{ width: 40, marginTop: -4 }} className='my-2' src={star} alt="doge" /> */}
                    <div style={{ fontSize: 12, marginTop: -5 }}>
                      <strong className="text-light">50% complete</strong>
                    </div>
                  </CircularProgressbarWithChildren>
                ) : (
                  <CircularProgressbarWithChildren
                    value={0}
                    styles={buildStyles({ pathColor: `gold` })}
                  >
                    {/* <img style={{ width: 40, marginTop: -4 }} className='my-2' src={star} alt="doge" /> */}
                    <div style={{ fontSize: 12, marginTop: -5 }}>
                      <strong className="text-light">0% complete</strong>
                    </div>
                  </CircularProgressbarWithChildren>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <br />

      <div className="row">
        <div className="col-md-3 mx-auto">
          <button
            onClick={handleClick}
            className="btn btnConfirm w-100 fw-bold px-5"
          >
            Back{" "}
          </button>
        </div>
        {/* <button className='btn border-warning fw-bold mx-3  px-5 Cri-btn'>Edit</button> */}
      </div>
    </div>
  );
};

export default CricketJerseySouvenir;
